module.exports = __webpack_public_path__ + "static/media/poo-storm.df4d685a.svg";